module.exports = __webpack_public_path__ + "static/img/sin-fi-1.367e37c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/sin-fi-1.jpg
// module id = 3YoP
// module chunks = 1